'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _PageForm = _interopRequireDefault(require("Components/Forms/Models/Page/PageForm"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class NewPagePage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Back.default, (0, _extends2.default)({
      page_title: "Nouvelle page"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: (0, _Routing.URL)('AdminPagesDashboard'),
      component: _Link.default,
      className: "u-margin-bottom-15"
    }, '<', " Retour aux pages"), /*#__PURE__*/_react.default.createElement(_PageForm.default, {
      "edit-url": true
    })));
    return output;
  }
}
exports.default = NewPagePage;
